"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Theme = require("../Theme");

var _Util = require("../Util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var types = {
  error: {
    color: _Theme.colors.white,
    backgroundColor: _Theme.colors.red
  },
  warning: {
    color: _Theme.colors.white,
    backgroundColor: _Theme.colors.yellow
  },
  success: {
    color: _Theme.colors.white,
    backgroundColor: _Theme.colors.green
  },
  primary: {
    color: _Theme.colors.white,
    backgroundColor: _Theme.colors.blue
  },
  reverse: {
    color: _Theme.colors.white,
    backgroundColor: _Theme.colors.primary
  }
};

function Badge(props) {
  var newProps = (0, _Util.mergeProps)(props, Badge, ['style']); // eslint-disable-next-line object-curly-newline

  var type = newProps.type,
      content = newProps.content,
      children = newProps.children,
      style = newProps.style,
      className = newProps.className,
      forwardedRef = newProps.forwardedRef,
      rest = _objectWithoutProperties(newProps, ["type", "content", "children", "style", "className", "forwardedRef"]);

  var styles = Object.assign(types[type] || types.primary, style);
  return _react["default"].createElement(Span, Object.assign({
    ref: forwardedRef,
    component: "span",
    className: className,
    style: styles
  }, rest), content || children);
}

Badge.propTypes = {
  children: _propTypes["default"].any.isRequired,
  content: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(Object.keys(types)),
  className: _propTypes["default"].string,
  style: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string])
};
Badge.defaultProps = {
  type: 'primary',
  content: '',
  className: '',
  style: '{}'
};

var _default = _react["default"].forwardRef(function (props, ref) {
  return _react["default"].createElement(Badge, Object.assign({}, props, {
    forwardedRef: ref
  }));
});

exports["default"] = _default;
var Span = (0, _styledComponents["default"])(_Typography["default"]).withConfig({
  displayName: "Badge__Span",
  componentId: "sc-1kkh0ds-0"
})(["&&{display:inline-flex;justify-content:center;align-items:center;padding:2px 10px;height:24px;line-height:24px;}"]);